import { api } from "@/lib/api";

const MAX_SIDE = 1600;

const loadImage = (file) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = reject;
  img.src = URL.createObjectURL(file);
});

export async function compressImage(file) {
  if (file.type === "image/gif") return file;
  try {
    const img = await loadImage(file);
    const scale = Math.min(1, MAX_SIDE / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * scale); c.height = Math.round(img.height * scale);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(img.src);
    const blob = await new Promise((r) => c.toBlob(r, "image/jpeg", 0.85));
    return blob ? new File([blob], "bild.jpg", { type: "image/jpeg" }) : file;
  } catch {
    return file;
  }
}

export async function uploadImage(endpoint, file) {
  const fd = new FormData();
  fd.append("file", await compressImage(file));
  const { data } = await api.post(endpoint, fd);
  return data;
}
